import React from 'react';
import PropTypes from 'prop-types';
import { FelaComponent } from 'react-fela';
import Spin from 'antd/lib/spin';
import { childrenPropType } from 'ackee-frontend-toolkit/es/components';

const loaderRule = ({ theme }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',

    '& .ant-spin-dot i': {
        backgroundColor: theme.colors.black,
    },
    '& .ant-spin-text': {
        color: theme.colors.black,
        fontSize: '1.5em',
    },
});

const SimpleLoader = ({ children, show, text }) => (
    <div>
        {children}
        {show && (
            <FelaComponent rule={loaderRule}>
                <Spin tip={text} size="large" />
            </FelaComponent>
        )}
    </div>
);

SimpleLoader.propTypes = {
    children: childrenPropType.isRequired,
    show: PropTypes.bool.isRequired,
    text: PropTypes.string,
};

SimpleLoader.defaultProps = {
    text: 'Loading...',
};

export default SimpleLoader;
